import { useEffect, useState } from 'react'

import { Button, Container, Link, Stack, Text } from '../components'
import { WarningTriangle } from '../components/icons/icons'

export function NoMatch({ children, title = 'Not Found!', healthCheck }) {
  const [apiDown, setApiDown] = useState(false)
  const [checking, setChecking] = useState(true)

  const checkApiHealth = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_HOST}/health/api`)
      const healthData = await response.json()

      if (healthData.status === 'down') {
        setApiDown(true)
        console.error('The API service is currently down.')
      } else {
        setApiDown(false)
      }
    } catch (error) {
      setApiDown(true)
    } finally {
      setChecking(false)
    }
  }

  useEffect(() => {
    if (healthCheck) {
      checkApiHealth()
    } else {
      setChecking(false)
    }
  }, [healthCheck])

  const handleRetry = () => {
    window.location.reload()
  }

  if (checking && healthCheck) {
    return (
      <Container maxWidth="lg">
        <Stack alignItems="center" spacing={2}>
          <Text.H1>Loading...</Text.H1>
        </Stack>
      </Container>
    )
  }

  if (apiDown) {
    return (
      <Container maxWidth="lg">
        <Stack spacing={3} alignItems="center">
          <WarningTriangle
            style={{
              fontSize: '4em',
              color: 'var(--orange)',
              mb: 2,
            }}
          />
          <Text.H3 style={{ textAlign: 'center' }}>
            We&apos;re currently experiencing a temporary outage. Our team is working on it — please check back shortly.
          </Text.H3>
          <Text.H3 style={{ textAlign: 'center' }}>
            To report this issue, please contact us at{' '}
            <Link href="mailto:support@givewise.ca">support@givewise.ca</Link>
          </Text.H3>
          <Button onClick={handleRetry}>Retry</Button>
        </Stack>
      </Container>
    )
  }

  return (
    <Container maxWidth="lg">
      <Stack>
        <Text.H1>{title}</Text.H1>
        {children}
      </Stack>
    </Container>
  )
}
